/**
 * The words for "you are not part of an organisation" (#2688). One copy, three places: the
 * blocked screen (signed in, token and membership list both empty), the callback page (Auth0
 * refused the sign-in) and the ACUL organisation picker (empty list).
 */
export const NO_ORGANISATION_TITLE = "You're not part of an organisation yet"
export const NO_ORGANISATION_MESSAGE =
  "Ask your organisation's administrator to invite you, then sign in again."

/** Auth0's refusal text when the tenant enforces organisations and the user has none (#2688). */
export const AUTH0_NO_ORGANISATION_ERROR = 'does not belong to any organization'
